import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { CtaButton } from "../ui/CtaButton";
export function BonusesSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-37" data-mp="qek2dz5r0z49">
      <div className="mx-auto max-w-5xl" data-id="element-38" data-mp="vb0rowoopjix">
        <SectionHeading eyebrow="Your Five Exclusive Bonuses" title="5 Professional Resources Included FREE With Your Purchase" subtitle="Additional ways to study, practice, organize, and review endodontic concepts." data-id="element-39" data-mp="vc2efyf2bugh" />

        <div className="mt-12 space-y-14" data-id="element-40" data-mp="19cd633o75d2p">
          {bonuses.map(b => <article key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10" data-id="element-41" data-mp="1eaer3u56nmgt">
              <div className="-mx-5 sm:mx-0" data-id="element-42" data-mp="220iqfpbc9020">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full bg-paper sm:rounded-3xl" data-id="element-43" data-mp="21ypkydcgolvl" />
              </div>
              <div className="mt-6 md:mt-0" data-id="element-44" data-mp="2m5s64cjmoshu">
                <div className="flex flex-wrap items-center gap-3" data-id="element-45" data-mp="2h6nttd1eqena">
                  <span className="flex items-center gap-1.5 rounded-full bg-navy px-3 py-1.5 text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-46" data-mp="2h4b94s49lq6j">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="2r3k6zw293oy6" />
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-muted" data-id="element-48" data-mp="34u5kf58xr6oo">
                    Reference value <s className="text-danger" data-id="element-49" data-mp="2zwdo7z19cyeo">${b.value}</s>{" "}
                    <strong className="text-cta" data-id="element-50" data-mp="3eufvokbeu417">FREE today</strong>
                  </span>
                </div>
                <h3 className="mt-4 font-display text-[1.7rem] font-bold leading-tight text-ink sm:text-3xl" data-id="element-51" data-mp="39w4nee0rk1l3">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink/85" data-id="element-52" data-mp="1kgeys4zf7r3r">{b.intro}</p>
                <ul className="mt-4 space-y-2" data-id="element-53" data-mp="1fimvketbsik9">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-54" data-mp="256itac0koy3f">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-55" data-mp="297kkc5kc63ub" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 text-sm italic leading-relaxed text-muted" data-id="element-56" data-mp="2j60ao6bjh92r">{b.note}</p>
              </div>
            </article>)}
        </div>
        <div className="mt-14" data-id="element-57" data-mp="2s5ngr5f7r325">
          <CtaButton label="Yes, I Want All 5 Bonuses" size="md" data-id="element-58" data-mp="2s4vifmu8er86" />
        </div>
      </div>
    </section>;
}